module.exports = __webpack_public_path__ + "img/fuwushiyong.8ae192d7.png";